// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"dac9a9b6","231":"c803b5d6","237":"791f56bb","256":"d642c06f","483":"3370c94e","534":"42a8eb7b","588":"d6b05fbf","625":"9dd5ea85","723":"0f24156c","743":"dd2ab5ed","797":"493b5b16","972":"7c747f34"}[chunkId] + ".chunk.js";
};